import { render, staticRenderFns } from "./el-autocomplete.vue?vue&type=template&id=11988c96"
import script from "./el-autocomplete.vue?vue&type=script&lang=js"
export * from "./el-autocomplete.vue?vue&type=script&lang=js"
import style0 from "./el-autocomplete.vue?vue&type=style&index=0&id=11988c96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports